var map = {
	"./1.png": 444,
	"./2.png": 343,
	"./3.png": 976,
	"./4.png": 552,
	"./about-banner.png": 504,
	"./feautres-banner.png": 208,
	"./footer-bg.png": 712,
	"./hero-banner.png": 604,
	"./hero-bg-bottom.png": 240,
	"./hero-bg.png": 440,
	"./service-banner-pattern.png": 528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 656;